import { render, staticRenderFns } from "./ServiceTasksEditPage.vue?vue&type=template&id=b3632c5a&"
import script from "./ServiceTasksEditPage.vue?vue&type=script&lang=ts&"
export * from "./ServiceTasksEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports